import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { SelectChangeEvent } from '@mui/material';

import { CustomAlert, CustomButton, MultipleSelect } from '../../shared/uiComponents';
import { DispatchProperties, useSelector } from '../../redux/store';
import {
	assignClinicalSupervisors,
	getBCBAClinicalSupervisors,
	getClinicalSupervisors,
} from '../../redux/State/userSlice';
import { errorNormalizer } from '../../shared/Helpers/functions';

const Content = ({ onClose }: { onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { userId } = useParams();

	const [supervisorIds, setSupervisorIds] = useState<string[]>([]);

	const clinicalSupervisors = useSelector((state) => state.user.clinicalSupervisors);

	const clinicalSupervisorsHandler = (event: SelectChangeEvent<string[]>) => {
		const { value } = event.target;

		if (typeof value === 'string') return;
		setSupervisorIds(value);
	};

	const saveSupervisorsHandler = () => {
		if (!userId) return;
		dispatch(
			assignClinicalSupervisors({
				userId,
				supervisorIds,
			}),
		)
			.then(unwrapResult)
			.then(() => toast('Success'))
			.catch(errorNormalizer)
			.finally(onClose);
	};

	useEffect(() => {
		dispatch(
			getClinicalSupervisors({
				page: '1',
				pageSize: '100',
			}),
		);
	}, [dispatch]);

	useEffect(() => {
		if (!userId) return;
		dispatch(getBCBAClinicalSupervisors(userId))
			.then(unwrapResult)
			.then((response) => {
				const ids = response.map((x) => x.id);
				setSupervisorIds(ids);
			});
	}, [dispatch, userId]);

	return (
		<>
			<MultipleSelect
				data={
					clinicalSupervisors.query
						? clinicalSupervisors.query.map((x) => ({
								id: x.id,
								name: x.fullName,
							}))
						: []
				}
				setValue={clinicalSupervisorsHandler}
				initialValue={supervisorIds}
				label="Clinical Supervisors"
				className="marginBottom16"
			/>
			<CustomButton title="Save" onClick={saveSupervisorsHandler} className="marginBottom16" />
			<CustomButton title="Cancel" onClick={onClose} buttonType="secondaryGray" />
		</>
	);
};

const AssignClinicalSupervisor = () => {
	const [open, setOpen] = useState<boolean>(false);
	const user = useSelector((state) => state.user.user);
	const isLoading = useSelector((state) => state.user.loading);

	return (
		<>
			<CustomButton
				disabled={isLoading}
				title="Edit Clinical Supervisors"
				onClick={() => setOpen(true)}
				className="marginBottom16"
				buttonType="outlined"
			/>
			<CustomAlert
				isBusy={isLoading}
				open={open}
				onClose={() => setOpen(false)}
				Content={Content}
				title={`Assign Clinical Supervisors to ${user.fullName}`}
			/>
		</>
	);
};

export default AssignClinicalSupervisor;
